/**
 * Imports
 *
 * Import any modules or components here.
 */
import { cookieDuration, i18n } from "commonAssets/js/constants";
import { setCookie } from "commonAssets/lib/setCookie.js";
import { getSubmissionGuid } from "../utils/getSubmissionGuid";
import { getAngeionTestParam } from "../utils/getAngeionTestParam";

/**
 * A class representing a set of methods for handling cookies.
 * @class
 * @property {number} duration - The duration of the cookie.
 * @since 3.0.0
 */
export class Cookies {
    constructor(duration = cookieDuration) {
        this.duration = duration;
    }

    init() {
        // Check if cookies are enabled in the browser.
        if (navigator.cookieEnabled) {
            this.uuid();
            this.referrer();
            this.language();
            getSubmissionGuid();
            getAngeionTestParam();
        } else {
            console.log("Cookies are not enabled in your browser.");
        }
    }

    uuid() {
        let uuid = this.getCookie("uuid");

        if (!uuid) {
            uuid = this.generateUUID();
            this.setCookie("_ag_UUID", uuid, this.duration);
        }

        return uuid;
    }

    referrer() {
        const referrer = document.referrer;
        if (referrer) {
            setCookie("_ag_URL", document.referrer, this.duration);
        }
        return null;
    }

    _validateLanguage(language) {
        const validLanguages = i18n.languages;
        return validLanguages.includes(language);
    }

    language() {
        const urlParams = new URLSearchParams(window.location.search);
        let language = urlParams.get("language");
        const cookieLanguage = this.getCookie("_ag_Lang");

        if (!language && !cookieLanguage) {
            language = "en";
        } else if (!language && this._validateLanguage(cookieLanguage)) {
            language = cookieLanguage;
        } else if (this._validateLanguage(language)) {
            // Set the language cookie for future use.
            this.setCookie("_ag_Lang", language, 365);
        } else {
            language = "en";
        }
        i18n.userLanguage = language;
        return language;
    }

    locale() {
        return i18n.getTranslation("locale");
    }

    generateUUID() {
        const array = new Uint8Array(16);
        window.crypto.getRandomValues(array);
        let hex = "";
        for (let i = 0; i < array.length; i++) {
            hex += (array[i] >>> 4).toString(16);
            hex += (array[i] & 0x0f).toString(16);
        }
        return hex;
    }

    setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toGMTString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}
